var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"animation-root"},[_c('div',{staticClass:"img-container"},[_c('img',{style:(_vm.currentFrame.style),attrs:{"src":_vm.currentFrame.img}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }